import { useTranslation } from 'react-i18next'

import { drawing } from 'resources/images'

import SectionTitle from 'components/SectionTitle'

import { OurStoryWrapper, SectionContent, SectionImage } from './styles'

function OurStory() {
	const { t } = useTranslation()

	return (
		<OurStoryWrapper id="our-story">
			<div className="container">
				<SectionTitle>{t('Nossa História')}</SectionTitle>

				<SectionContent>
					<SectionImage
						className="float-end"
						src={drawing}
						alt=""
						loading="lazy"
					/>
					<p>{t('ourStory.part1')}</p>
					<p>{t('ourStory.part2')}</p>
					<p>{t('ourStory.part3')}</p>
					<p>{t('ourStory.part4')}</p>
					<p>{t('ourStory.part5')}</p>
					<p>{t('ourStory.part6')}</p>
				</SectionContent>
			</div>
		</OurStoryWrapper>
	)
}

export default OurStory
